import React from "react";

const SendButton = () => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.85804 4.55167L0 0.420898V9.62343H5.83731L6.85804 4.55167Z"
        fill="white"
      />
      <path
        d="M16.6829 10.4203L8.74034 5.66748L6.57129 16.4968L16.6829 10.4203Z"
        fill="white"
      />
      <path
        d="M5.42263 11.6807H0V20.4207L4.16267 17.9326L5.42263 11.6807Z"
        fill="white"
      />
    </svg>
  );
};

export default SendButton;
